/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Safe_Neat_Mule_RideInputs */

const en_safe_neat_mule_ride = /** @type {(inputs: Safe_Neat_Mule_RideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User`)
};

const de_safe_neat_mule_ride = /** @type {(inputs: Safe_Neat_Mule_RideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer`)
};

/**
* | output |
* | --- |
* | "User" |
*
* @param {Safe_Neat_Mule_RideInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const safe_neat_mule_ride = /** @type {((inputs?: Safe_Neat_Mule_RideInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Safe_Neat_Mule_RideInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_safe_neat_mule_ride(inputs)
	return de_safe_neat_mule_ride(inputs)
});